import { render, staticRenderFns } from "./DistributionOfOtherOverheads.vue?vue&type=template&id=c4b1e368"
import script from "./DistributionOfOtherOverheads.vue?vue&type=script&lang=js"
export * from "./DistributionOfOtherOverheads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports